import React from 'react';
import './footer.css';

function Footer(props) {
  return <div className='footer'>{props.children} </div>;
}

export default Footer;
